var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoWalmart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274.581,
    height: 32.138,
    viewBox: "0 0 274.581 32.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(-60 -9.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(136 -28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M-66.285-.513A.513.513,0,0,0-65.772,0h1.026a.531.531,0,0,0,.513-.513V-6.858h4.455a6.073,6.073,0,0,0,6.021-6.075A6.039,6.039,0,0,0-59.805-18.9h-5.967a.513.513,0,0,0-.513.513Zm2.052-8.343v-7.992h4.293a3.852,3.852,0,0,1,4.1,3.861,4.024,4.024,0,0,1-4.1,4.131Zm13.149,3.7c0,3.294.864,5.454,4.455,5.454a5.031,5.031,0,0,0,3.861-1.62c.081.837.513,1.431,1.323,1.431a.454.454,0,0,0,.486-.486v-11.5a.614.614,0,0,0-.567-.594h-.837a.594.594,0,0,0-.567.594v8.559a4.619,4.619,0,0,1-3.537,1.809c-1.809,0-2.619-1.134-2.619-3.618v-6.75a.618.618,0,0,0-.594-.594h-.81a.6.6,0,0,0-.594.594Zm13.554-1.08C-37.53-2.673-35.262.3-31.482.3a7.665,7.665,0,0,0,4.563-1.431c.459-.351.351-.486.108-.864l-.324-.459c-.324-.486-.513-.378-.945-.081a5.794,5.794,0,0,1-3.375,1.026,4.391,4.391,0,0,1-4.077-4.266h9.072a.583.583,0,0,0,.567-.54,7.115,7.115,0,0,0,.054-.756,5.483,5.483,0,0,0-5.643-5.67C-35.262-12.744-37.53-9.747-37.53-6.237ZM-35.5-7.371a4.083,4.083,0,0,1,4.023-3.564,3.648,3.648,0,0,1,3.645,3.564ZM-22.572-.594A.6.6,0,0,0-21.978,0h.81a.618.618,0,0,0,.594-.594v-8.64A3.941,3.941,0,0,1-17.2-10.827a3.139,3.139,0,0,1,1.35.351.473.473,0,0,0,.729-.3l.351-.972c.3-.864-1.242-1-2.187-1a5.147,5.147,0,0,0-3.834,1.566c-.081-.81-.513-1.4-1.3-1.4a.454.454,0,0,0-.486.486Zm10.557-2.781A3.425,3.425,0,0,0-8.586.3,6.04,6.04,0,0,0-5.643-.459c.324-.189.378-.405.216-.81l-.216-.54c-.108-.3-.3-.54-.783-.243a3.813,3.813,0,0,1-1.917.54,1.657,1.657,0,0,1-1.674-1.863v-7.371h3.672a.605.605,0,0,0,.621-.594v-.54a.589.589,0,0,0-.621-.594h-3.672v-3.51a.561.561,0,0,0-.567-.594l-.837.054a.639.639,0,0,0-.594.594ZM-3.4-6.264A6.458,6.458,0,0,0,2.862.3,6.458,6.458,0,0,0,9.126-6.264a6.421,6.421,0,0,0-6.264-6.48A6.421,6.421,0,0,0-3.4-6.264Zm1.971,0a4.464,4.464,0,0,1,4.293-4.671A4.443,4.443,0,0,1,7.128-6.264,4.483,4.483,0,0,1,2.862-1.512,4.5,4.5,0,0,1-1.431-6.264ZM19.494-.513A.513.513,0,0,0,20.007,0H21.06a.531.531,0,0,0,.513-.513V-7.4H26.73L30.24-.405A.585.585,0,0,0,30.834,0h1.3a.511.511,0,0,0,.459-.783l-3.7-6.858a6.028,6.028,0,0,0,4-5.508A5.8,5.8,0,0,0,27-18.9H20.007a.513.513,0,0,0-.513.513ZM21.627-9.18v-7.749h5.238a3.927,3.927,0,0,1,3.888,3.807A3.936,3.936,0,0,1,26.865-9.18ZM36.288-.594A.6.6,0,0,0,36.882,0h.81a.618.618,0,0,0,.594-.594V-11.88a.639.639,0,0,0-.594-.594h-.81a.618.618,0,0,0-.594.594Zm.945-15.093a1.475,1.475,0,0,0,1.485-1.458,1.47,1.47,0,0,0-1.485-1.512,1.465,1.465,0,0,0-1.458,1.512A1.469,1.469,0,0,0,37.233-15.687ZM41.688-6.21A6.171,6.171,0,0,0,47.979.3a5.724,5.724,0,0,0,4.7-2.511c.216-.324.108-.594-.162-.864l-.162-.162c-.351-.351-.7-.459-1.053-.054a4.053,4.053,0,0,1-3.4,1.782,4.45,4.45,0,0,1-4.185-4.725,4.486,4.486,0,0,1,4.266-4.7,3.88,3.88,0,0,1,3.132,1.35c.243.27.486.54.891.189l.432-.405a.6.6,0,0,0,.108-.891,5.807,5.807,0,0,0-4.536-2.052A6.309,6.309,0,0,0,41.688-6.21Zm13.365-.054A6.458,6.458,0,0,0,61.317.3a6.458,6.458,0,0,0,6.264-6.561,6.421,6.421,0,0,0-6.264-6.48A6.421,6.421,0,0,0,55.053-6.264Zm1.971,0a4.464,4.464,0,0,1,4.293-4.671,4.443,4.443,0,0,1,4.266,4.671,4.483,4.483,0,0,1-4.266,4.752A4.5,4.5,0,0,1,57.024-6.264Z",
    transform: "translate(131 63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Walmart_logo",
    transform: "translate(60 9.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M126.413,25.364c0-3.174-1.359-5.978-5.953-5.978a10.843,10.843,0,0,0-5.245,1.26l.744,2.546a7.739,7.739,0,0,1,3.834-1.069c2.326,0,2.707,1.313,2.707,2.159v.2c-5.078-.008-8.288,1.746-8.288,5.319a4.223,4.223,0,0,0,4.478,4.23,5.127,5.127,0,0,0,4.084-1.809h.085s.578,2.42,3.777,1.495a21.076,21.076,0,0,1-.223-3.379Zm-3.788,3.351a2.445,2.445,0,0,1-.1.751,2.652,2.652,0,0,1-2.556,1.8,1.734,1.734,0,0,1-1.891-1.856c0-1.922,2.122-2.451,4.544-2.438",
    transform: "translate(-48.673 -8.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M0,11.861S3.317,25.43,3.844,27.628c.621,2.569,1.733,3.519,4.943,2.886L10.86,22.1c.524-2.085.88-3.58,1.219-5.7h.057a55.981,55.981,0,0,0,1,5.71s.846,3.823,1.285,5.825,1.63,3.266,4.779,2.582l4.935-18.654H20.153L18.46,19.93c-.448,2.338-.856,4.179-1.173,6.321h-.058c-.286-2.119-.649-3.885-1.115-6.175l-1.754-8.215H10.2L8.33,19.866C7.8,22.31,7.3,24.27,6.983,26.345H6.929C6.606,24.4,6.167,21.919,5.7,19.567c0,0-1.112-5.732-1.5-7.706",
    transform: "translate(0 -5.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M52.346,25.364c0-3.174-1.362-5.978-5.957-5.978a10.849,10.849,0,0,0-5.242,1.26l.744,2.546a7.714,7.714,0,0,1,3.834-1.069c2.326,0,2.707,1.313,2.707,2.159v.2c-5.078-.008-8.291,1.746-8.291,5.319a4.225,4.225,0,0,0,4.472,4.23A5.11,5.11,0,0,0,48.7,32.226h.089s.582,2.42,3.777,1.495a20.918,20.918,0,0,1-.22-3.379Zm-3.791,3.351a2.551,2.551,0,0,1-.094.751,2.66,2.66,0,0,1-2.563,1.8,1.735,1.735,0,0,1-1.888-1.856c0-1.922,2.122-2.451,4.544-2.438",
    transform: "translate(-17.107 -8.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M65.012,11.861V30.508H68.8V11.861Z",
    transform: "translate(-27.705 -5.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M155.753,11.861V25.619c0,1.9.356,3.223,1.124,4.035a4.224,4.224,0,0,0,3.088,1.175,9.185,9.185,0,0,0,2.75-.406l-.046-2.962a6.075,6.075,0,0,1-1.446.168c-1.294,0-1.722-.82-1.722-2.525V19.836h3.3V16.273h-3.3V11.861",
    transform: "translate(-66.376 -5.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M138.675,19.718V33.729h3.92V26.554a5.292,5.292,0,0,1,.085-1.028,2.953,2.953,0,0,1,3.095-2.471,6.558,6.558,0,0,1,1.124.105V19.487a4.022,4.022,0,0,0-4.682,2.88h-.1V19.718",
    transform: "translate(-59.098 -8.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M75.456,19.718V33.729h3.819V25.506a3.2,3.2,0,0,1,.179-1.137,2.563,2.563,0,0,1,2.318-1.8c1.538,0,2.264,1.3,2.264,3.171v7.987h3.81V25.407A3.919,3.919,0,0,1,88,24.277,2.39,2.39,0,0,1,90.3,22.572c1.554,0,2.306,1.27,2.306,3.478v7.68h3.806V25.468c0-4.34-2.208-6.062-4.715-6.062a5.069,5.069,0,0,0-2.768.757,6,6,0,0,0-1.776,1.74h-.057a4,4,0,0,0-3.869-2.5,4.405,4.405,0,0,0-4.084,2.21h-.058v-1.9",
    transform: "translate(-32.156 -8.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M202.149,10.819a1.388,1.388,0,0,0,1.462-.894l.743-8.411c0-.833-.981-1.515-2.2-1.515s-2.2.682-2.2,1.515l.749,8.411a1.376,1.376,0,0,0,1.456.894",
    transform: "translate(-85.209)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M188.571,18.459a1.379,1.379,0,0,0-.051-1.712L181.587,11.9c-.721-.421-1.8.081-2.418,1.142s-.491,2.249.215,2.661l7.675,3.558a1.372,1.372,0,0,0,1.511-.808",
    transform: "translate(-76.186 -5.008)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M211.535,18.454a1.411,1.411,0,0,0,1.513.818l7.675-3.568c.713-.421.82-1.6.217-2.658s-1.7-1.559-2.421-1.147l-6.934,4.843a1.415,1.415,0,0,0-.041,1.718",
    transform: "translate(-90.039 -5.009)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M202.149,37.163a1.388,1.388,0,0,1,1.462.894l.743,8.411c0,.833-.981,1.508-2.2,1.508s-2.2-.675-2.2-1.508l.749-8.411a1.376,1.376,0,0,1,1.456-.894",
    transform: "translate(-85.209 -15.837)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M211.535,31.949c.393-.652,1.035-1,1.513-.812l7.675,3.562c.713.412.82,1.6.217,2.661s-1.7,1.554-2.421,1.142l-6.934-4.849a1.394,1.394,0,0,1-.041-1.7",
    transform: "translate(-90.039 -13.248)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M188.571,31.941a1.38,1.38,0,0,1-.051,1.712l-6.933,4.841c-.721.421-1.8-.082-2.418-1.135s-.491-2.249.215-2.661l7.675-3.562a1.37,1.37,0,0,1,1.511.8",
    transform: "translate(-76.186 -13.247)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M231.041,41.939h.1c.13,0,.182.041.2.145a.713.713,0,0,0,.071.225h.246a.448.448,0,0,1-.064-.232.262.262,0,0,0-.182-.22v-.023a.224.224,0,0,0,.2-.215.284.284,0,0,0-.085-.2.669.669,0,0,0-.335-.071,1.553,1.553,0,0,0-.358.035v.93h.218Zm.007-.424.112-.015c.131,0,.2.061.2.146s-.1.14-.217.14h-.1Zm.14-.631a.943.943,0,1,0,.959.936.939.939,0,0,0-.959-.936m0,.189a.751.751,0,0,1,0,1.5.751.751,0,0,1-.007-1.5",
    transform: "translate(-98.111 -17.424)",
    fill: "#ffb300"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWalmart);
export default __webpack_public_path__ + "static/media/logo-walmart.5b47f5fdc679010c051da43ed23e85bf.svg";
export { ForwardRef as ReactComponent };